module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_heat.b3845.png";